/**
 * Component: References
 * Requires flickity for the slideshow
 */

var ed = ed || {};

ed.references = new function(){
    /**
     * Init function
     */
    this.activateSlideshow = function() {
        if (window.innerWidth < 992) {
            // mobile view
            slideshow('create');
        }
        else {
            // desktop view
            slideshow('destroy');
        }
    };

    var isFlickity = false;

    /**
     * Slideshow
     * This slideshow will only activate if we are on a mobile size.
     * The references are tabbed navigation on larger screens.
     */
    function slideshow(action) {
            var referenceList = $('.reference-list'),
            referenceItem = '.reference-container';

        if (action === 'create' && !isFlickity) {
            // Remove display none class
            referenceList.removeClass('js-hidden');

            // Trigger redraw for transition
            referenceList.first().offsetHeight;

            // Init flickity
            referenceList.flickity({
                adaptiveHeight: true,
                cellAlign: 'left',
                // cellSelector: referenceItem,
                accessibility: false,
                pageDots: false,
                contain: true,
                arrowShape: {
                    x0: 10,
                    x1: 60, y1: 50,
                    x2: 70, y2: 40,
                    x3: 30
                }
            });

            // Dispatch a resize event to make sure sliders aren't cut in half cause of weird load timings
            window.dispatchEvent(new Event('resize'));

            isFlickity = true;
        }

        else if (action === 'destroy' && isFlickity) {
            referenceList.flickity('destroy');
            referenceList.flickity('reloadCells');
            isFlickity = false;
        }
    }
};
